import { Text, View, Font, Image } from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";
import { DataRow, DataRowThreeImage, DataRowThreeText } from "../DataRow";
import { PageWrapper, styles, tableStyles } from "../SmartTitanProjektPDF";
import InvoiceTableBlankSpace from "../InvoiceTableBlankSpace";
import { DataTableGroup } from "../DataTableGroup";
import KiloNewton from "../../Math/Units/Metric/KiloNewton";
import Metre from "../../Math/Units/Metric/Metre";
import Degree from "../../Math/Units/Metric/Degree";
import druckImageDE from "../../../images/druck_1.png";
import druckImageEN from "../../../images/20231011_Druckpfahlgruppe_EN.png";

export function GermanyAussereDruckNachweisGruppe({ data }) {
  const { t, i18n } = useTranslation("translation");
  let itemIndex = 1;

  return (
    <PageWrapper Deckblatt={data.Deckblatt}>
      <View>
        {/* Äußere Tragfähigkeit */}
        {/* <Text style={styles.section}>
          {t("aeussre.outerLoadCarryingCapacity")}
        </Text> */}

        {/* Nachweis Druckpfahlgruppe */}

        <Text style={styles.sectionSubText}>{t("aeussre.pileGroupCheckboxText_pdf")}</Text>

        <View style={tableStyles.tableContainer}>
          {/* Bemessungslast der gesamten Pfahlgruppe */}
          <DataRow
            item={{
              title: t("aeussre.designLoadPileGroup"),
              value: data.Germany.Aussere.NachweisDruckpfahlgruppe.bemessungslastGesamtePfahlgruppe,
              // F_{d, tot}
              // https://latex.codecogs.com/png.image?\inline&space;\dpi{110}\bg{white}F_{d,&space;tot}
              // https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}F_{d,&space;tot}
              bezImage: {
                uri: "https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}F_{d,&space;tot}",
                height: 9,
                width: 19,
              },
              valueScale: 0,
              itemIndex: itemIndex++,
              valueUnit: <KiloNewton />,
            }}
          />

          {/* Teilsicherheitsbeiwert */}
          <DataRow
            item={{
              title: t("aeussre.partialSafetyFactor"),
              value: data.Germany.Aussere.NachweisDruckpfahlgruppe.teilsicherheitsbeiwert,
              // \gamma_s
              // https://latex.codecogs.com/png.image?\inline&space;\dpi{110}\bg{white}\gamma_s
              // https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}\\gamma_s
              bezImage: {
                uri: "https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}\\gamma_s",
                height: 6,
                width: 7,
              },
              valueScale: 2,
              itemIndex: itemIndex++,
            }}
          />

          {/* Kantenlängen Ersatzpfahl la*/}
          <DataRow
            item={{
              title: t("aeussre.overallDimensions"),
              value: data.Germany.Aussere.NachweisDruckpfahlgruppe?.kantenlaengenErsatzpfahl?.la,
              // l_a
              // https://latex.codecogs.com/png.image?\inline&space;\dpi{110}\bg{white}l_a
              // https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}l_a
              bezImage: {
                uri: "https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}l_a",
                height: 7,
                width: 6,
              },
              valueScale: 2,
              itemIndex: itemIndex++,
              valueUnit: <Metre />,
            }}
          />

          {/* Kantenlängen Ersatzpfahl lb*/}
          <DataRow
            item={{
              title: "",
              value: data.Germany.Aussere.NachweisDruckpfahlgruppe?.kantenlaengenErsatzpfahl?.lb,
              // l_b
              // https://latex.codecogs.com/png.image?\inline&space;\dpi{110}\bg{white}l_b
              // https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}l_b
              bezImage: {
                uri: "https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}l_b",
                height: 7,
                width: 6,
              },
              valueScale: 2,
              itemIndex: itemIndex++,
              valueUnit: <Metre />,
            }}
          />

          {/* Umfang Ersatzpfahl */}
          <DataRow
            item={{
              title: t("aeussre.perimeterPileGroup"),
              value: data.Germany.Aussere.NachweisDruckpfahlgruppe.umfangErsatzpfahl,
              // U
              // https://latex.codecogs.com/png.image?\inline&space;\dpi{110}\bg{white}U
              // https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}U
              bezImage: {
                uri: "https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}U",
                height: 6,
                width: 6,
              },
              valueScale: 2,
              itemIndex: itemIndex++,
              valueUnit: <Metre />,
            }}
          />

          {/* erforderliche Pfahllänge */}
          <DataRow
            item={{
              title: t("aeussre.requiredPileLength"),
              value: data.Germany.Aussere.NachweisDruckpfahlgruppe.erforderlichePfahllaenge,
              // L_{req}
              // https://latex.codecogs.com/png.image?\inline&space;\dpi{110}\bg{white}L_{req}
              // https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}L_{req}
              bezImage: {
                uri: "https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}L_{req}",
                height: 9,
                width: 15,
              },
              valueScale: 2,
              itemIndex: itemIndex++,
              valueUnit: <Metre />,
            }}
          />
        </View>

        <DataTableGroup
          item={data.Germany.Aussere.NachweisDruckpfahlgruppe.tabelle}
          tableInput={data.Germany.Aussere.NachweisDruckpfahlgruppe.tabelle.zeilenEingegeben}
          tableCalculated={data.Germany.Aussere.NachweisDruckpfahlgruppe.tabelle.zeilenBerechnet}
          sumRsdi={data.Germany.Aussere.NachweisDruckpfahlgruppe.tabelle.sumRsdi}
          lreq={data.Germany.Aussere.NachweisDruckpfahlgruppe.tabelle.lreq}
        />
        <View style={{ alignItems: "center", marginTop: 20 }}>
          <Image
            style={{ width: "150" }}
            src={i18n.language === "de-DE" ? druckImageDE : druckImageEN}
          />
        </View>
      </View>
    </PageWrapper>
  );
}

export function GermanyAussereZugNachweisGruppe({ data }) {
  const { t } = useTranslation("translation");
  let itemIndex = 1;

  return (
    <PageWrapper Deckblatt={data.Deckblatt}>
      <View>
        {/* Nachweis Zugpfahlgruppe */}
        <Text style={styles.sectionSubText}>{t("aeussre.verificationCheckboxText_pdf")}</Text>

        {/* Geometrische Parameter Erdkörper */}
        <Text style={styles.sectionSubText}>{t("aeussre.geometricParametersEarthBody")}</Text>

        <View style={tableStyles.tableContainer}>
          {/* Pfahllänge */}
          <DataRow
            item={{
              title: t("aeussre.pileLength"),
              value: data.Germany.Aussere.NachweisZugpfahlgruppe.pfahllaenge,
              // L_{nom}
              // https://latex.codecogs.com/png.image?\inline&space;\dpi{110}\bg{white}L_{nom}
              // https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}L_{nom}
              bezImage: {
                uri: "https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}L_{nom}",
                height: 7,
                width: 18,
              },
              valueScale: 2,
              itemIndex: itemIndex++,
              valueUnit: <Metre />,
            }}
          />

          {/* größeres Rastermaß */}
          <DataRow
            item={{
              title: t("aeussre.largerGridDimension"),
              value: data.Germany.Aussere.NachweisZugpfahlgruppe.groeßeresRastermaß,
              // l_{a}
              // https://latex.codecogs.com/png.image?\inline&space;\dpi{110}\bg{white}l_{a}
              // https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}l_{a}
              bezImage: {
                uri: "https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}l_{a}",
                height: 7,
                width: 6,
              },
              valueScale: 2,
              itemIndex: itemIndex++,
              valueUnit: <Metre />,
            }}
          />

          {/* größeres Rastermaß */}
          <DataRow
            item={{
              title: t("aeussre.smallerGridDimension"),
              value: data.Germany.Aussere.NachweisZugpfahlgruppe.kleineresRastermaß,
              // l_{b}
              // https://latex.codecogs.com/png.image?\inline&space;\dpi{110}\bg{white}l_{b}
              // https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}l_{b}
              bezImage: {
                uri: "https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}l_{b}",
                height: 7,
                width: 6,
              },
              valueScale: 2,
              itemIndex: itemIndex++,
              valueUnit: <Metre />,
            }}
          />

          {/* Reibungswinkel Baugrund */}
          <DataRow
            item={{
              title: t("aeussre.internalFrictionAngle"),
              value: data.Germany.Aussere.NachweisZugpfahlgruppe.reibungswinkelBaugrund,
              // \varphi
              // https://latex.codecogs.com/png.image?\inline&space;\dpi{110}\bg{white}\varphi
              // https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}\\varphi
              bezImage: {
                uri: "https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}\\varphi",
                height: 6,
                width: 5,
              },
              valueScale: 2,
              itemIndex: itemIndex++,
              valueUnit: <Degree />,
            }}
          />

          {/* Wichte Baugrund */}
          <DataRow
            item={{
              title: t("aeussre.soilDensity"),
              value: data.Germany.Aussere.NachweisZugpfahlgruppe.wichteBaugrund,
              // \gamma
              // https://latex.codecogs.com/png.image?\inline&space;\dpi{110}\bg{white}\gamma
              // https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}\\gamma
              bezImage: {
                uri: "https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}\\gamma",
                height: 6,
                width: 5,
              },
              valueScale: 2,
              itemIndex: itemIndex++,
              valueUnit: "kN/m³",
            }}
          />
        </View>

        {/* Einwirkungen */}
        <Text style={styles.sectionSubText}>{t("aeussre.impactsPileGroup")}</Text>

        <View style={tableStyles.tableContainer}>
          {/* Anzahl der Zugpfähle */}
          <DataRow
            item={{
              title: t("aeussre.numberTensionPiles"),
              value: data.Germany.Aussere.NachweisZugpfahlgruppe.anzahlZugpfaehle,
              // n_z
              // https://latex.codecogs.com/png.image?\inline&space;\dpi{110}\bg{white}n_z
              // https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}n_z
              bezImage: {
                uri: "https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}n_z",
                height: 5,
                width: 8,
              },
              valueScale: 2,
              itemIndex: itemIndex++,
              valueUnit: t("aeussre.pieces"),
            }}
          />

          {/* ständige destabilisierende Einwirkungen */}
          <DataRow
            item={{
              title: t("aeussre.permanentlyDestabilisingVerticalAction"),
              value:
                data.Germany.Aussere.NachweisZugpfahlgruppe.staendigeDestabilisierendeEinwirkungen,
              // G_{dst,k}
              // https://latex.codecogs.com/png.image?\inline&space;\dpi{110}\bg{white}G_{dst,k}
              // https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}G_{dst,k}
              bezImage: {
                uri: "https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}G_{dst,k}",
                height: 9,
                width: 21,
              },
              valueScale: 2,
              itemIndex: itemIndex++,
              valueUnit: <KiloNewton />,
            }}
          />

          {/* Teilsicherheitsbeiwert für destabilisierende ständige Einwirkungen */}
          <DataRow
            item={{
              title: t("aeussre.partialSafetyFactorDestabilisingPermanentActions"),
              value:
                data.Germany.Aussere.NachweisZugpfahlgruppe
                  .teilsicherheitsbeiwertDestabilisierendeStaendigeEinwirkungen,
              // \gamma_{ _{G,dst}}
              // https://latex.codecogs.com/png.image?\inline&space;\dpi{110}\bg{white}\gamma_{&space;_{G,dst}}
              // https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}\\gamma_{&space;_{G,dst}}
              bezImage: {
                uri: "https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}\\gamma_{&space;_{G,dst}}",
                height: 7,
                width: 18,
              },
              valueScale: 2,
              itemIndex: itemIndex++,
            }}
          />

          {/* veränderliche destabilisierende Einwirkungen */}
          <DataRow
            item={{
              title: t("aeussre.destabilisingVariableActions"),
              value:
                data.Germany.Aussere.NachweisZugpfahlgruppe
                  .veraenderlicheDestabilisierendeEinwirkungen,
              // Q_{dst,rep}
              // https://latex.codecogs.com/png.image?\inline&space;\dpi{110}\bg{white}Q_{dst,rep}
              // https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}Q_{dst,rep}
              bezImage: {
                uri: "https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}Q_{dst,rep}",
                height: 9,
                width: 26,
              },
              valueScale: 2,
              itemIndex: itemIndex++,
              valueUnit: <KiloNewton />,
            }}
          />

          {/* Teilsicherheitsbeiwert für destabilisierende veränderliche Einwirkungen */}
          <DataRow
            item={{
              title: t("aeussre.partialSafetyFactorDestabilisingVariableActions"),
              value:
                data.Germany.Aussere.NachweisZugpfahlgruppe
                  .teilsicherheitsbeiwertDestabilisierendeVeraenderlicheEinwirkungen,
              // \gamma_{ _{Q,dst}}
              // https://latex.codecogs.com/png.image?\inline&space;\dpi{110}\bg{white}\gamma_{&space;_{Q,dst}}
              // https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}\\gamma_{&space;_{Q,dst}}
              bezImage: {
                uri: "https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}\\gamma_{&space;_{Q,dst}}",
                height: 7,
                width: 18,
              },
              valueScale: 2,
              itemIndex: itemIndex++,
            }}
          />

          {/* ständige stabilisierende Einwirkungen */}
          <DataRow
            item={{
              title: t("aeussre.permanentlyStabilisingVerticalAction"),
              value:
                data.Germany.Aussere.NachweisZugpfahlgruppe.staendigeStabilisierendeEinwirkungen,
              // G_{stb,k}
              // https://latex.codecogs.com/png.image?\inline&space;\dpi{110}\bg{white}G_{stb,k}
              // https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}G_{stb,k}
              bezImage: {
                uri: "https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}G_{stb,k}",
                height: 9,
                width: 20,
              },
              valueScale: 2,
              itemIndex: itemIndex++,
              valueUnit: <KiloNewton />,
            }}
          />

          {/* Teilsicherheitsbeiwert für günstige ständige Einwirkungen */}
          <DataRow
            item={{
              title: t("aeussre.psfCase1A"),
              value:
                data.Germany.Aussere.NachweisZugpfahlgruppe
                  .teilsicherheitsbeiwertGuenstigeStaendigeEinwirkungen,
              // \gamma_{ _{G,stb}}
              // https://latex.codecogs.com/png.image?\inline&space;\dpi{110}\bg{white}\gamma_{&space;_{G,stb}}
              // https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}\\gamma_{&space;_{G,stb}}
              bezImage: {
                uri: "https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}\\gamma_{&space;_{G,stb}}",
                height: 7,
                width: 17,
              },
              valueScale: 2,
              itemIndex: itemIndex++,
            }}
          />

          {/* Gewichtskraft des angehängten Erdkörper */}
          <DataRow
            item={{
              title: t("aeussre.weightSoilAttachedPileGroup"),
              value:
                data.Germany.Aussere.NachweisZugpfahlgruppe.gewichtskraftAngehaengtenErdkoerper,
              // G_{E,k}
              // https://latex.codecogs.com/png.image?\inline&space;\dpi{110}\bg{white}G_{E,k}
              // https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}G_{E,k}
              bezImage: {
                uri: "https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}G_{E,k}",
                height: 9,
                width: 17,
              },
              valueScale: 0,
              itemIndex: itemIndex++,
              valueUnit: <KiloNewton />,
            }}
          />

          {/* Anpassungsfaktor */}
          <DataRow
            item={{
              title: t("aeussre.adjustmentFactor"),
              value: data.Germany.Aussere.NachweisZugpfahlgruppe.anpassungsfaktor,
              // \eta_z
              // https://latex.codecogs.com/png.image?\inline&space;\dpi{110}\bg{white}\eta_z
              // https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}\eta_z
              bezImage: {
                uri: "https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}\\eta_z",
                height: 6,
                width: 7,
              },
              valueScale: 2,
              itemIndex: itemIndex++,
            }}
          />

          <DataRowThreeImage
            item={{
              // Q_{dst,k} \cdot\gamma_{G,dst,rep} + Q_{dst,rep} \cdot \gamma_{Q,dst}
              // https://latex.codecogs.com/png.image?\inline&space;\dpi{110}\bg{white}Q_{dst,k}&space;\cdot\gamma_{G,dst,rep}&space;&plus;&space;Q_{dst,rep}&space;\cdot&space;\gamma_{Q,dst}
              // https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}G_{dst,k}&space;\\cdot\\gamma_{G,dst,rep}&plus;Q_{dst,rep}&space;\\cdot&space;\\gamma_{Q,dst}
              value1Image: {
                uri: "https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}G_{dst,k}&space;\\cdot\\gamma_{G,dst,rep}&plus;Q_{dst,rep}&space;\\cdot&space;\\gamma_{Q,dst}",
                height: 9,
                width: 122,
              },

              signImage: {
                uri: "https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}\\leq",
                height: 5,
                width: 6,
              },
              //
              // https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}G_{stb,k}\\cdot\\gamma_{G,stb}&plus;G&space;_{E,k}\\cdot\\gamma_{G,stb}
              value2Image: {
                uri: "https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}G_{stb,k}\\cdot\\gamma_{G,stb}&plus;G&space;_{E,k}\\cdot\\gamma_{G,stb",
                height: 9,
                width: 98,
              },

              valueScale: 0,
              itemIndex: itemIndex++,
              unit: <KiloNewton />,
            }}
          />
          <DataRowThreeText
            item={{
              value_one: data.Germany.Aussere.NachweisZugpfahlgruppe.left,
              value_two: data.Germany.Aussere.NachweisZugpfahlgruppe.right,

              // \eta_z
              // https://latex.codecogs.com/png.image?\inline&space;\dpi{110}\bg{white}\eta_z
              // https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}\eta_z
              // value1Image: {
              //   uri: "https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}L_{req}",
              //   height: 9,
              //   width: 15,
              // },
              // value2Image: {
              //   uri: "https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}L_{req}",
              //   height: 9,
              //   width: 15,
              // },
              signImage: {
                uri: "https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}\\leq",
                height: 5,
                width: 6,
              },
              valueScale: 0,
              itemIndex: itemIndex++,
              unit: <KiloNewton />,
            }}
          />

          {/* Erforderliche Pfahllänge */}
          <DataRow
            item={{
              title: t("aeussre.pileLengthRequired"),
              value: data.Germany.Aussere.NachweisZugpfahlgruppe.erforderlichePfahllaenge,
              // \eta_z
              // https://latex.codecogs.com/png.image?\inline&space;\dpi{110}\bg{white}\eta_z
              // https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}\eta_z
              bezImage: {
                uri: "https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}L_{req}",
                height: 9,
                width: 15,
              },
              valueScale: 2,
              itemIndex: itemIndex++,
              valueUnit: <Metre />,
            }}
          />
          <InvoiceTableBlankSpace rowsCount={25 - itemIndex} />
        </View>
      </View>
    </PageWrapper>
  );
}
